import React, { useContext } from 'react';
import { useFloatingContext, FloatingWrapper } from '@elliemae/ds-floating-context';
import { styled } from '@elliemae/ds-system';
import { ControlledDateTimePickerContext } from '../../../ControlledDateTimePickerCTX.js';
import {
  ControlledDateTimePickerDatatestid,
  DSControlledDateTimePickerName,
  DSControlledDateTimePickerSlots,
} from '../../../constants/index.js';
import { CalendarWithTimeWheelContent } from './CalendarWithTimeWheelContent.js';
import { CalendarWithTimeWheelContext } from './CalendarWithTimeWheelContext.js';

const StyledFloatingWrapper = styled(FloatingWrapper, {
  name: DSControlledDateTimePickerName,
  slot: DSControlledDateTimePickerSlots.CONTEXTUAL_MENU.CALENDAR_TIMEWHEEL,
})``;

export const CalendarWithTimeWheelWrapper = () => {
  const { referenceElement, closeCalendar, isControllerOnly } = useContext(CalendarWithTimeWheelContext);
  const { getProps } = useContext(ControlledDateTimePickerContext);

  const {
    refs,
    floatingStyles,
    context,
    isOpen: isFloatingOpen,
  } = useFloatingContext({
    externallyControlledIsOpen: !isControllerOnly && !!referenceElement,
    externalReferenceElement: referenceElement,
    withoutAnimation: true,
    customOffset: [0, 0],
    onClickOutside: isControllerOnly ? undefined : closeCalendar,
  });

  if (isControllerOnly) return <CalendarWithTimeWheelContent />;
  if (!referenceElement) return null;

  return (
    <StyledFloatingWrapper
      innerRef={refs.setFloating}
      isOpen={isFloatingOpen}
      floatingStyles={floatingStyles}
      context={context}
      data-testid={ControlledDateTimePickerDatatestid.CONTEXTUAL_MENU.CALENDAR_TIMEWHEEL}
      getOwnerProps={getProps}
      aria-label="calendar header"
      role="dialog"
    >
      <CalendarWithTimeWheelContent />
    </StyledFloatingWrapper>
  );
};
